import { Checkbox, Dialog, DialogContent, DialogTitle, FilledInput, FormControl, FormControlLabel, InputLabel, makeStyles, MenuItem, Select } from '@material-ui/core';
import { Observer } from 'mobx-react';
import * as React from 'react';
import { clientVersion } from '../main/clientVersion_tmp';
import { transl } from '../main/transl';
import { useOmnistore } from '../stores/Omnistore';

const servers = [
	'',
	'dev1.octopusorder.com',
	'mini1.octopusorder.com',
	'local.octopusorder.com',
];
const speeds = '1 2 5 10 20 60 300 3600'.split(' ');
const ratios = '1 2 5 10 20 50 100'.split(' ');
const roles = ['STANDARD', 'HARMONIZER', 'ADMIN', 'SUPPLIER'];

const useStyles = makeStyles({
	dialogContent: {
		width: 500,
		display: 'grid',
		gridTemplateColumns: '1fr 1fr',
		gridGap: 20,
	},
	control: {
		width: '100%',
	},
});

function BoolEdit(props: {value: boolean, onChange() : void, name: string}) {
	const {value, onChange, name} = props;
	const classes = useStyles();
	return <Observer>{() =>
		<FormControl className={classes.control}>
			<FormControlLabel
				label={transl(name)}
				control={<Checkbox name={name} checked={value} color="default" onChange={onChange}/>}
			/>
		</FormControl>
	}</Observer>;
}

export function TesterDialog() {
	const classes = useStyles();
	const omnistore = useOmnistore();
	const authStore = omnistore.authStore;
	const reoctoStore = omnistore.reoctoStore;

	const onClose = () => reoctoStore.setShowTesterDialog(false);

	return <Observer>{() =>
		<Dialog open={reoctoStore.showTesterDialog} onClose={onClose}>
			<DialogTitle>Testing {clientVersion}</DialogTitle>
			<DialogContent className={classes.dialogContent}>
				<BoolEdit
					name="isTester"
					value={reoctoStore.isTester}
					onChange={() => reoctoStore.setIsTester(!reoctoStore.isTester)}
				/>
				<BoolEdit
					name="honorLocation"
					value={reoctoStore.honorLocation}
					onChange={() => reoctoStore.setHonorLocation(!reoctoStore.honorLocation)}
				/>
				<BoolEdit
					name="useNet"
					value={reoctoStore.useNet}
					onChange={() => reoctoStore.setUseNet(!reoctoStore.useNet)}
				/>
				<BoolEdit
					name="useDb"
					value={reoctoStore.useDb}
					onChange={() => reoctoStore.setUseDb(!reoctoStore.useDb)}
				/>
				<BoolEdit
					name="useServiceWorkerLoader"
					value={reoctoStore.useServiceWorkerLoader}
					onChange={() => reoctoStore.setUseServiceWorkerLoader(!reoctoStore.useServiceWorkerLoader)}
				/>
				<BoolEdit
					name="skipTranslation"
					value={reoctoStore.skipTranslation}
					onChange={() => reoctoStore.setSkipTranslation(!reoctoStore.skipTranslation)}
				/>
				<BoolEdit
					name="ignoreProblems"
					value={reoctoStore.ignoreProblems}
					onChange={() => reoctoStore.setIgnoreProblems(!reoctoStore.ignoreProblems)}
				/>
				<div/>
				<FormControl className={classes.control}>
					<InputLabel>Refresh period</InputLabel>
					<Select
						value={reoctoStore.refreshPeriod}
						onChange={e => reoctoStore.setRefreshPeriod(+(e.target.value as any))}
						input={<FilledInput name="refresh"/>}>
						{speeds.map(s => <MenuItem value={s} key={s}>{s}</MenuItem>)}
					</Select>
				</FormControl>
				<FormControl className={classes.control}>
					<InputLabel>Slow refresh ratio</InputLabel>
					<Select
						value={reoctoStore.slowRefreshRatio}
						onChange={e => reoctoStore.setSlowRefreshRatio(+(e.target.value as any))}
						input={<FilledInput name="ration"/>}>
						{ratios.map(s => <MenuItem value={s} key={s}>{s}</MenuItem>)}
					</Select>
				</FormControl>
				<FormControl className={classes.control}>
					<InputLabel>Role</InputLabel>
					<Select
						value={authStore.role}
						onChange={e => authStore.setRole(e.target.value as any)}
						input={<FilledInput name="role"/>}>
						{roles.map(s => <MenuItem value={s} key={s}>{s}</MenuItem>)}
					</Select>
				</FormControl>
				<FormControl className={classes.control}>
					<InputLabel shrink>Server</InputLabel>
					<Select
						value={authStore.server}
						displayEmpty
						onChange={e => authStore.setServer(e.target.value as any)}
						input={<FilledInput name="server"/>}>
						{servers.map(s => <MenuItem value={s} key={s}>{s ? s : '(default)'}</MenuItem>)}
					</Select>
				</FormControl>
			</DialogContent>
		</Dialog>
	}</Observer>;
}
